import type { Participant, event_network_quality_change } from "@zoom/videosdk";
import { LocalParticipant } from "../../../core/room/participant/LocalParticipant";
import { NetworkQualityChangeHandler } from "../../../core/room/participant/types";
import { VideoClient } from "../../types";

export class ZoomLocalParticipant implements LocalParticipant {
  #participant: Participant;
  #videoClient: VideoClient;

  constructor(participant: Participant, videoClient: VideoClient) {
    this.#participant = participant;
    this.#videoClient = videoClient;
  }

  /**
   * userIdentity is extracted from the Zoom JWT, where it is an optional property
   * We always provide user_identity in the JWT making this non-null assertion safe
   */
  get identity() {
    return this.#participant.userIdentity!;
  }

  get sid() {
    return String(this.#participant.userId);
  }

  on(
    _event: "networkQualityLevelChanged",
    handler: NetworkQualityChangeHandler,
  ) {
    const networkQualityChangeHandler = (
      payload: Parameters<typeof event_network_quality_change>[0],
    ) => {
      const { level, userId } = payload;
      if (userId === this.#participant.userId) {
        // payload.type specifies 'uplink' or 'downlink', which is different from Twilio
        handler(level);
      }
    };

    this.#videoClient.on("network-quality-change", networkQualityChangeHandler);

    return () => {
      this.#videoClient.on(
        "network-quality-change",
        networkQualityChangeHandler,
      );
    };
  }
}
